import request from '@/utils/request'
import connectedCarInfoJson from './mock/connectedCarInfo.json'

//커넥트카 정보
export function connectedCarInfo(appfFomNo, dealCd, opmkNo, itemSn, naviSn, uiccId, usimMdlNm, usimSn, imei, ctn, entrLoc) {
    let params = {
        appfFomNo: appfFomNo,
        dealCd: dealCd,
        opmkNo: opmkNo,        
        itemSn: itemSn,
        naviSn: naviSn,
        uiccId: uiccId,
        usimMdlNm: usimMdlNm,
        usimSn: usimSn,
        imei: imei,
        ctn: ctn,
        entrLoc: entrLoc
    }
    return request({
        url: `/ococ/datacapture/v1/openmarket/connectedCar/connectedCarInfo`,
        method: 'get',
        params
    }) 
    // return new Promise ( function(resolve, reject) {
    //     resolve(connectedCarInfoJson)
    // })
}

//커넥트카 유플가입 고객정보 조회
export function custInfo(ipinCi) {
    let params = {
        ipinCi: ipinCi
    }
    return request({
        url: `/ococ/datacapture/v1/openmarket/connectedCar/custInfo`,
        method: 'get',
        params
    }) 
}
 

// 필요 없음
// i-pin 인증 데이터 저장
export function saveiPin(reqData) {
    let mobileInfo = {
        chrgPymnDivsCd: reqData.chrgPymnDivsCd,
        onetMblAppfNo: reqData.onetMblAppfNo,
        secureData1: reqData.secureData1,
        secureData2: reqData.secureData2,
        secureData3: reqData.secureData3,
        secureData4: reqData.secureData4
    }
    return request({
        url: `/ococ/datacapture/v1/openmarket/connectedCar/iPin`,
        method: 'post',
        data: mobileInfo
    })
}